/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Available_Extras_Empty_StateInputs */

const en_admin_resource_form_available_extras_empty_state = /** @type {(inputs: Admin_Resource_Form_Available_Extras_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer extras like catering or equipment with this resource`)
};

const de_admin_resource_form_available_extras_empty_state = /** @type {(inputs: Admin_Resource_Form_Available_Extras_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biete Extras wie Catering oder Equipment zu dieser Ressource an`)
};

const es_admin_resource_form_available_extras_empty_state = /** @type {(inputs: Admin_Resource_Form_Available_Extras_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofrece extras como catering o equipamiento con este recurso`)
};

const fr_admin_resource_form_available_extras_empty_state = /** @type {(inputs: Admin_Resource_Form_Available_Extras_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposez des suppléments comme un traiteur ou du matériel avec cette ressource`)
};

const nl_admin_resource_form_available_extras_empty_state = /** @type {(inputs: Admin_Resource_Form_Available_Extras_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bied extras zoals catering of apparatuur aan bij deze voorziening`)
};

/** @type {(inputs: Admin_Resource_Form_Available_Extras_Empty_StateInputs) => LocalizedString} */
const it_admin_resource_form_available_extras_empty_state = en_admin_resource_form_available_extras_empty_state;

/** @type {(inputs: Admin_Resource_Form_Available_Extras_Empty_StateInputs) => LocalizedString} */
const pt_br2_admin_resource_form_available_extras_empty_state = en_admin_resource_form_available_extras_empty_state;

/** @type {(inputs: Admin_Resource_Form_Available_Extras_Empty_StateInputs) => LocalizedString} */
const pl_admin_resource_form_available_extras_empty_state = en_admin_resource_form_available_extras_empty_state;

/** @type {(inputs: Admin_Resource_Form_Available_Extras_Empty_StateInputs) => LocalizedString} */
const hu_admin_resource_form_available_extras_empty_state = en_admin_resource_form_available_extras_empty_state;

/** @type {(inputs: Admin_Resource_Form_Available_Extras_Empty_StateInputs) => LocalizedString} */
const ro_admin_resource_form_available_extras_empty_state = en_admin_resource_form_available_extras_empty_state;

/**
* | output |
* | --- |
* | "Offer extras like catering or equipment with this resource" |
*
* @param {Admin_Resource_Form_Available_Extras_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_available_extras_empty_state = /** @type {((inputs?: Admin_Resource_Form_Available_Extras_Empty_StateInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Available_Extras_Empty_StateInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_available_extras_empty_state(inputs)
	if (locale === "de") return de_admin_resource_form_available_extras_empty_state(inputs)
	if (locale === "es") return es_admin_resource_form_available_extras_empty_state(inputs)
	if (locale === "fr") return fr_admin_resource_form_available_extras_empty_state(inputs)
	if (locale === "nl") return nl_admin_resource_form_available_extras_empty_state(inputs)
	if (locale === "it") return it_admin_resource_form_available_extras_empty_state(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_available_extras_empty_state(inputs)
	if (locale === "pl") return pl_admin_resource_form_available_extras_empty_state(inputs)
	if (locale === "hu") return hu_admin_resource_form_available_extras_empty_state(inputs)
	return ro_admin_resource_form_available_extras_empty_state(inputs)
});
export { admin_resource_form_available_extras_empty_state as "admin.resource_form.available_extras_empty_state" }